/*
  assets/b-accordion.js  (#433)  Custom element <b-accordion> for blocks/b-accordion.liquid.

  The items are native <details>, so opening and closing needs no script. This adds:
  - "one open at a time": each own item gets the same <details name>, and siblings
    are closed here too for browsers without `name` support;
  - theme editor: selecting a block inside an item opens that item (and any
    accordion items around it);
  - `b-accordion:toggle` (bubbles) with detail.open and detail.title.
  Only this accordion's own items are touched, never those of an accordion nested
  inside one of them.
*/
if (!customElements.get('b-accordion')) {
  class BAccordion extends HTMLElement {
    connectedCallback() {
      this.single = this.dataset.single === 'true';
      if (this.single) this.ownItems().forEach((item) => item.setAttribute('name', this.dataset.group));

      this.onToggle = (event) => {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !this.owns(item)) return;
        if (item.open && this.single) {
          this.ownItems().forEach((other) => {
            if (other !== item && other.open) other.open = false;
          });
        }
        const title = item.querySelector(':scope > summary .b-accordion-item__title');
        this.dispatchEvent(new CustomEvent('b-accordion:toggle', {
          bubbles: true,
          detail: { open: item.open, title: title ? title.textContent.trim() : '' }
        }));
      };
      this.onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        let item = event.target.closest('details.b-accordion-item');
        while (item && this.contains(item)) {
          item.open = true;
          item = item.parentElement && item.parentElement.closest('details.b-accordion-item');
        }
      };

      // `toggle` doesn't bubble: listen in the capture phase.
      this.addEventListener('toggle', this.onToggle, true);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('toggle', this.onToggle, true);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    owns(item) {
      return item.matches('details.b-accordion-item') && item.closest('b-accordion') === this;
    }

    ownItems() {
      return Array.from(this.querySelectorAll('details.b-accordion-item')).filter((item) => this.owns(item));
    }
  }

  customElements.define('b-accordion', BAccordion);
}
